import Vue from 'vue'
import VueResource from 'vue-resource'
import store from '../store'
Vue.use(VueResource)

let apiurl = 'https://affiliate.i80.com.tw'

if (window.localStorage) {
  let downData = false
  let Today = new Date()
  Today = Today.getFullYear() + '-' + (Today.getMonth() + 1) + '-' + Today.getDate()
  let dataTime = new Date(window.localStorage.getItem('dataTime'))
  dataTime = dataTime.getFullYear() + '-' + (dataTime.getMonth() + 1) + '-' + dataTime.getDate()
  // console.log(Today + '----' + dataTime)
  if (dataTime === null || Today !== dataTime) {
    // window.localStorage.setItem('dataTime', Today)
    downData = true
    // 每天讓使用者登出
    // store.dispatch('LOGOUT')
  }

  let news = window.localStorage.getItem('news')
  if (news !== '' || news === 'null' || downData === true) {
    Vue.http.get(apiurl + '/api/get_news').then(function (res) {
      let data = res.body.data
      store.dispatch('SET_NEWS', data)
    }, function () {
      console.log('Load news failed')
    })
  } else {
    store.dispatch('SET_NEWS', JSON.parse(news))
  }

  let products = window.localStorage.getItem('products')
  if (products === '' || products === 'null' || downData === true) {
    Vue.http.get(apiurl + '/api/getProduct').then(function (res) {
      let data = res.body.data

      // 重新整理產品資料結構
      let product = []
      for (let i = 0; i < data.length; i++) {
        let price = data[i].price + data[i].itemfee
        let AnProduct = {
          id: data[i].id,
          fid: data[i].fid,
          name: data[i].name,
          price: price,
          oprice: data[i].oprice,
          firstprice: data[i].firstprice,
          point: data[i].point,
          imageM: data[i].imageM,
          imageL: data[i].imageL,
          showPrice: data[i].showPrice,
          content: data[i].content,
          sorting: data[i].lorder,
          quantity: 1,
          maximum: 20
        }
        product.push(AnProduct)
      }
      store.dispatch('SET_PRODUCTS', product)
    }, function () {
      console.log('Load products failed')
    })
  } else {
    store.dispatch('SET_PRODUCTS', JSON.parse(products))
  }

  let popular = window.localStorage.getItem('popular')
  if (popular === '' || popular === 'null' || downData === true) {
    Vue.http.get(apiurl + '/api/getPopular').then(function (res) {
      let data = res.body.data
      data.forEach(function (val, idx) {
        val.maximum = 1
      })
      store.dispatch('SET_POPULAR', data)
    }, function () {
      console.log('Load popular products failed')
    })
  } else {
    store.dispatch('SET_POPULAR', JSON.parse(popular))
  }

  let addon = window.localStorage.getItem('addon')
  if (!addon || downData === true) {
    Vue.http.get(apiurl + '/api/getAddonProduct').then(function (res) {
      let data = res.body.data
      data.forEach(function (val, idx) {
        val.maximum = 1
      })
      store.dispatch('SET_ADDON', data)
    }, function () {
      console.log('Load addon products failed')
    })
  } else {
    store.dispatch('SET_ADDON', JSON.parse(addon))
  }

  let companies = window.localStorage.getItem('companies')
  if (!companies || downData === true) {
    Vue.http.get(apiurl + '/api/get_affiliate').then(function (res) {
      let data = res.body.data
      let county = store.getters.getCounty
      let district = store.getters.getDistrict
      let CompanyArray = []
      for (let i = 0; i < data.length; i++) {
        let CountyKey = data[i].county - 1
        let CountyName = (county[data[i].county] && data[i].county > 0) ? county[data[i].county].text : ''
        let DistrictName = ''
        if (data[i].county > 0) {
          DistrictName = district[CountyKey][data[i].district].text
        }
        let CompanyData = {
          c_website: data[i].c_website,
          website_intro: data[i].website_intro,
          category_detail: data[i].category_detail,
          category_main: data[i].category_main,
          com_address: data[i].com_address,
          com_image: data[i].com_image,
          com_name: data[i].com_name,
          com_phone: data[i].com_phone,
          com_resize_image: data[i].com_resize_image,
          com_shopping: data[i].com_shopping,
          comid: data[i].comid,
          county: data[i].county,
          county_name: CountyName,
          district: data[i].district,
          district_name: DistrictName,
          delivery: data[i].delivery,
          free_delivery: data[i].free_delivery,
          free_delivery_set: data[i].free_delivery_set,
          lat: data[i].lat,
          lon: data[i].lon,
          m_factoryID: data[i].m_factoryID
        }
        CompanyArray.push(CompanyData)
      }
      store.dispatch('SET_COMPANIES', CompanyArray)
    }, function () {
      console.log('Load companies failed')
    })
  } else {
    store.dispatch('SET_COMPANIES', JSON.parse(companies))
  }

  let alliances = window.localStorage.getItem('alliances')
  if (!alliances || downData === true) {
    Vue.http.get(apiurl + '/api/alliance').then(function (res) {
      let data = res.body
      store.dispatch('SET_ALLIANCES', data)
    }, function () {
      console.log('Load alliances failed')
    })
  } else {
    store.dispatch('SET_ALLIANCES', JSON.parse(alliances))
  }

  // shopping cart
  let cart = window.localStorage.getItem('cart')
  if (cart !== '' && cart !== null) {
    store.dispatch('SAVE_TO_CART', JSON.parse(cart))
  } else if (cart === 'null') {
    store.dispatch('SAVE_TO_CART', [])
  }
} else {
  console.log('不支援暫時存取服務。')
}



// WEBPACK FOOTER //
// ./src/data/index.js